import React, { ReactNode } from 'react';
import { theme as antTheme } from 'antd';

import './base.css';

type Props = {
  children?: ReactNode;
};

const BasePane = ({ children }: Props) => {
  const { token } = antTheme.useToken();

  const styles = {
    basePane: {
      flex: 'auto',
      backgroundColor: token.colorBgContainer,
    },
  };

  return <div style={styles.basePane}>{children}</div>;
};

export default BasePane;
